import { useToast } from "vue-toastification";
export default function useErrors(error ,type ) {
    const toast = useToast();
 switch (error.response.status) {
     case 422:
         toast.error(`Le ${type} existe déjà`);
         break;
     case 500:
         toast.error(`Une erreur est survenue lors de la création du ${type}`);
         break;
    case 404:
        toast.error(`Le ${type} n'existe pas`);
        break;
    case 403:
        toast.error(`Vous n'avez pas les droits pour supprimer ce ${type}`);
        break;
    case 401:
        toast.error(`Vous n'êtes pas connecté`);
        break;
    case 400:
        toast.error(`Une erreur est survenue lors de la création du ${type}`);
        break;
    case 405:
        toast.error(`Une erreur est survenue lors de la création du ${type}`);
        break;
        
     default:
         toast.error(`Une erreur est survenue lors de la création du ${type}`);
         break;
 }
    
}